import { createContext, useContext } from 'react';
import { TooltipProps } from '../base-hover-tooltip/BaseHoverTooltip.types';

export type TTooltipContext = {
  closeTooltip: () => void;
  openTooltip: (Tooltip: TooltipProps) => void;
};

const TooltipContext = createContext<TTooltipContext>({
  closeTooltip: () => void 0,
  openTooltip: () => void 0,
});

const useTooltipContext = () => {
  return useContext(TooltipContext);
};

export { useTooltipContext, TooltipContext };
